export const NP_ENGINE = process.env.REACT_APP_BASE_URL;

export const WORDPRESS_HOME = process.env.REACT_APP_WORDPRESS_HOME;
export const IS_TRANSFER_PRIMARY_ALLOWED = false;
